import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "GreenRocky Carpet - Professional Carpet Cleaning Services",
  description = "Professional eco-friendly carpet cleaning services in Rockhampton City QLD. Green cleaning solutions, stain removal, and deep cleaning for homes and businesses.",
  keywords = "carpet cleaning, eco-friendly cleaning, stain removal, professional cleaners, green cleaning",
  author = "GreenRocky Carpet",
  url = "https://greenrockycarpet.com.au",
  image = "https://greenrockycarpet.com/images/og-image.jpg",
  type = "website",
  publishedTime,
  modifiedTime,
  section,
  tags = [],
  canonicalUrl,
  children 
}) => {
  const siteTitle = "GreenRocky Carpet - Professional Carpet Cleaning";
  const fullTitle = title === siteTitle ? title : `${title} | ${siteTitle}`;
  const siteName = "GreenRocky Carpet Cleaning";
  
  // Structured data for local business
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "HomeAndConstructionBusiness",
    "name": "GreenRocky Carpet Cleaning",
    "description": description,
    "url": url,
    "telephone": "+61-1300-989-330",
    "email": "info@greenrockycarpet.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "123 Clean Street",
      "addressLocality": "Green City",
      "addressRegion": "GC",
      "postalCode": "12345",
      "addressCountry": "AU"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "-33.8688",
      "longitude": "151.2093"
    },
    "openingHours": [
      "Mo-Su 07:00-21:00"
    ],
    "areaServed": {
      "@type": "GeoCircle",
      "geoMidpoint": {
        "@type": "GeoCoordinates",
        "latitude": "-33.8688",
        "longitude": "151.2093"
      },
      "geoRadius": "50000"
    },
    "serviceType": [
      "Carpet Cleaning",
      "Stain Removal",
      "Deep Cleaning",
      "Eco-Friendly Cleaning"
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Carpet Cleaning Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Standard Carpet Cleaning",
            "description": "Regular maintenance cleaning with eco-friendly products"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Premium Deep Cleaning",
            "description": "Intensive cleaning for heavily soiled carpets"
          }
        }
      ]
    }
  };

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <meta name="robots" content="index, follow" />
      
      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="en_AU" />
      
      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:site" content="@greenrockycarpet" />
      <meta name="twitter:creator" content="@greenrockycarpet" />
      
      {/* Additional Meta Tags */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="theme-color" content="#2e7d32" />
      <meta name="msapplication-TileColor" content="#2e7d32" />
      
      {/* Canonical URL */}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      
      {/* Article Specific Meta Tags */}
      {publishedTime && <meta property="article:published_time" content={publishedTime} />}
      {modifiedTime && <meta property="article:modified_time" content={modifiedTime} />}
      {section && <meta property="article:section" content={section} />}
      {tags.map(tag => (
        <meta key={tag} property="article:tag" content={tag} />
      ))}
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
      
      {/* Additional Children */}
      {children}
    </Helmet>
  );
};

export default SEO;